import React, { useMemo } from 'react';
import styled from 'styled-components';

import { ListItem } from './list-item';

type DraggableListItemPreviewProps = {
  primaryText: string;
  secondaryText: string;
  draggableRef: React.MutableRefObject<HTMLDivElement>;
};

export function DraggableListItemPreview({
  draggableRef,
  primaryText,
  secondaryText,
}: DraggableListItemPreviewProps): JSX.Element {
  const { width } = useMemo(() => draggableRef.current.getBoundingClientRect(), [draggableRef]);
  return (
    <StyledListItem
      style={{ width: width ? `${width}px` : 'unset' }}
      primaryText={primaryText}
      secondaryText={secondaryText}
    />
  );
}

const StyledListItem = styled(ListItem)`
  opacity: 0.75;
`;
